import { Model } from '@vuex-orm/core'

export class TeacherSubject extends Model {
  static entity = 'teacherSubject'
  static primaryKey = ['teacher_id', 'subject_id']

  static fields () {
    return {
      teacher_id: this.attr(null),
      subject_id: this.attr(null)
    }
  }
}

export default TeacherSubject
